import { ConfigType } from 'src/graphql';
import { TSimResultsStatus } from 'src/typings/base-types';

export const resultsStatus: TSimResultsStatus | undefined = undefined;
export const isLibrary = false;
export const configType: ConfigType = ConfigType.Simulation;
